import React from "react";
import {useTranslation} from "react-i18next";
import {useProductListContext} from "../organisms/productListProvider/ProductListProvider";

const ResetFiltersButton: React.FC = () => {
  const {t} = useTranslation();
  const {dispatch} = useProductListContext();

  const resetAllFilter = () => {
    dispatch({type: "RESET"});
    dispatch({type: "TRIGGER"});
  };

  return (
    <button className="filter-reset__button" onClick={resetAllFilter}>
      {t("product.resetAllFilters")}
      <span className="icon icon-back--blue" />
    </button>
  );
};

export default ResetFiltersButton;
